import React, { createContext, useContext, useState } from 'react';

interface FollowUp {
  id: number;
  title: string;
  createdAt: string;
  status: 'pending' | 'in-progress' | 'completed';
  assignee: string;
  description: string;
  tag?: 'triage' | 'own' | 'delegate' | 'archive';
}

interface FollowUpsContextType {
  followUps: Record<number, FollowUp>;
  updateFollowUp: (id: number, updates: Partial<FollowUp>) => void;
}

const FollowUpsContext = createContext<FollowUpsContextType | undefined>(undefined);

export function FollowUpsProvider({ children }: { children: React.ReactNode }) {
  const [followUps, setFollowUps] = useState<Record<number, FollowUp>>({});

  const updateFollowUp = (id: number, updates: Partial<FollowUp>) => {
    setFollowUps(prev => ({
      ...prev,
      [id]: { ...prev[id], ...updates }
    }));
  };

  return (
    <FollowUpsContext.Provider value={{ followUps, updateFollowUp }}>
      {children}
    </FollowUpsContext.Provider>
  );
}

export function useFollowUps() {
  const context = useContext(FollowUpsContext);
  if (context === undefined) {
    throw new Error('useFollowUps must be used within a FollowUpsProvider');
  }
  return context;
}